const useSetLanguage = (langCode: string): void => {
  const switchLocalePath = useSwitchLocalePath()
  // switchLocalePath don't keep query, so we do it by ourself
  const query = useRoute().fullPath.split('?')[1]

  useRouter().replace(switchLocalePath(langCode) + (query ? `?${query}` : ''))
}

export default useSetLanguage
